import React from 'react';
import { Link } from 'react-router-dom';
import TitleHelmet from 'components/TitleHelmet';
import { KoFiDialog, KoFiButton, KoFiWidget, KoFiPanel } from 'react-kofi';
import 'react-kofi/dist/styles.css';

const About: React.FC = () => {
  return (
    <div>
      <TitleHelmet title="About Fat Scientist" />

      <h1>About Fat Scientist</h1>
      <div>
        <img
          src="/images/tedZeppelin121.png"
          alt="TedZeppelin121 avatar"
          style={{ float: 'left', marginRight: '15px', width: '150px', height: 'auto' }}
        />
        <p>
          Fat Scientist was created by Reddit user{' '}
          <Link to="https://www.reddit.com/user/tedzeppelin121">TedZeppelin121</Link>, a compounded tirzepatide user
          whose own relationship with the medication started in 2024. An active participant on the{' '}
          <Link to="https://www.reddit.com/r/tirzepatidecompound">r/tirzepatidecompound</Link>, subreddit (along with
          other relevant subreddits), I came to see many of the same questions being asked over and over again. So I
          decided to create this website as a resource for the community, to provide accurate information and tools to
          help others on their tirzepatide and semaglutide journey.
        </p>
        <p>
          While the initial inspiration came from my direct personal experience with compounded tirzepatide, and that
          orientation made show through in some areas, my goal for the site is to include content and tools relevant for
          all GLP-1 users, whether namebrand or compounded, and semaglutide, tirzepatide, retatrutide, or whatever comes
          next.
        </p>

        <p>
          Fat Scientist is mostly a labor of love, built to give back to the GLP-1 community that has taught me so much.
          While I may explore modest monetization in the future (like Amazon affiliate links for products I personally
          use and trust, or light advertising), for now the site remains mostly free of commercial elements. If you find
          the site helpful and want to support its development, please consider{' '}
          <Link to="https://ko-fi.com/tedzeppelin121">buying me a coffee with Ko-fi</Link>!
        </p>

        <div id="kofi-widget-container" title="Ko-fi donation widget"></div>
        <KoFiButton color="#00b4f7" id="tedzeppelin121" label="Support Fat Scientist on Ko-Fi" radius="12px" />

        <p>
          The calculators are only the beginning -- I have a lot of plans for this site, including FAQs, injection and
          medication level modeling & tracking, vial testing coordination and reporting, and who knows what else the
          future could hold. If you have ideas or suggestions, please message me on Reddit!
        </p>
      </div>
    </div>
  );
};

export default About;
